// extracted by mini-css-extract-plugin
export default {"dashedContainer":"BlockType_dashedContainer__HUsIz"};